import React from 'react';
import PropTypes from 'prop-types';
import { FormattedText, formatText } from 'core/i18n';
import tools from 'utilities/tools';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import {
    getDay,
    getDayNameFromDate,
    getMonthNameFromDate,
    convertToValidFormatForDate,
} from 'utilities/dateHelper/dateHelper';

const getDateToVisit = (courierDate, postponed) => {
    if (postponed && typeof courierDate !== 'undefined') {
        return convertToValidFormatForDate(courierDate);
    }
};

const IdentityCourierMessages = ({
    courierAddress,
    courierAddressInfo,
    courierPostoned,
    courierDate,
    onHandleFinishIdentity,
}) => {
    const address = tools.getValueOrDefault(courierAddress);
    const additionalInfo =
        additionalInfo !== ''
            ? formatText('messagesScreen-corurierAdditionalInfoTemplate', [additionalInfo])
            : tools.getValueOrDefault(courierAddressInfo);
    const postponed = typeof courierPostoned !== 'undefined' ? courierPostoned : false;
    const dateToVisit = getDateToVisit(courierDate, postponed);

    const dayName = formatText(`daysOfWeek-${getDayNameFromDate(dateToVisit, 'en').toLowerCase()}`);
    const monthName = formatText(`fullMonths-${getMonthNameFromDate(dateToVisit, 'en', 'long').toLowerCase()}`);
    const day = String(getDay(dateToVisit)).padStart(2, '0');

    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-checked"
                title={<FormattedText value="messagesScreen-corurierFinishTitle" />}
                buttonText={formatText('button-continue')}
                showRoadmapNavigation={true}
                roadmapNavigationProps={{
                    buttonContinueAction: onHandleFinishIdentity,
                }}
            >
                <FormattedText
                    value="messagesScreen-corurierFinishContent"
                    injectedStrings={[address, additionalInfo, dayName, day, monthName]}
                />
                {postponed && (
                    <div className="courier-grey-box">
                        <i className="icons icons--icon-exclamation"></i>
                        <p className="font-paragraph2">
                            <FormattedText value="messagesScreen-corurierPostponedBox" />
                        </p>
                    </div>
                )}
            </MessagesScreen>
        </div>
    );
};

IdentityCourierMessages.propTypes = {
    courierAddress: PropTypes.string.isRequired,
    courierAddressInfo: PropTypes.string.isRequired,
    courierPostoned: PropTypes.string.isRequired,
    courierDate: PropTypes.string.isRequired,
    onHandleFinishIdentity: PropTypes.func.isRequired,
};

export default IdentityCourierMessages;
